// RefAdminConfig.jsx — Section Configuration extraite (5 sous-onglets : Identité, Stripe, Formules, Site public, Paramètres)
// Reçoit tout le state nécessaire en props. Rendu pur sans logique métier.

const SWATCHES = ['#4DFFD2', '#4f8aff', '#7c5cfc', '#ffad4d', '#ff5c6a', '#22d3a0', '#f59e0b', '#ec4899', '#06b6d4'];

export default function RefAdminConfig({
  tab,
  // Identité
  nom, setNom, slogan, setSlogan, desc, setDesc,
  brand, setBrand,
  shortName,
  // Live preview
  totalMembres,
  // Save
  showToast, saveConfig, livePending,
  // Formules editor
  editFormule, addFormule,
  formuleEditorOpen, setFormuleEditorOpen,
  feNom, setFeNom, feDesc, setFeDesc,
  fePrix, setFePrix, feFreq, setFeFreq,
  fePreviewPrice, fePreviewName, fePreviewPeriod,
}) {
  return (
    <div data-testid="section-config">

  {/* IDENTITÉ */}
  {tab === 'identite' && (
    <div data-testid="tab-identite">
      <div className="grid-2">
        <div>
          <div className="card">
            <div className="card-header"><div className="card-title">🏷️ Informations générales</div></div>
            <div className="card-body">
              <div className="form-group">
                <label className="form-label">Nom de l'association</label>
                <input className="form-input" value={nom} onChange={(e) => setNom(e.target.value)} data-testid="inp-nom" />
              </div>
              <div className="form-group">
                <label className="form-label">Slogan / Accroche</label>
                <input className="form-input" value={slogan} onChange={(e) => setSlogan(e.target.value)} data-testid="inp-slogan" />
              </div>
              <div className="form-group">
                <label className="form-label">Description courte</label>
                <textarea className="form-input" value={desc} onChange={(e) => setDesc(e.target.value)} data-testid="inp-desc" />
              </div>
              <div className="grid-2">
                <div className="form-group">
                  <label className="form-label">Email contact</label>
                  <input className="form-input" defaultValue="contact@ref-reseau.fr" />
                </div>
                <div className="form-group">
                  <label className="form-label">Téléphone</label>
                  <input className="form-input" defaultValue="+33 6 12 34 56 78" />
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Ville / Région</label>
                <input className="form-input" defaultValue="Lyon, Auvergne-Rhône-Alpes" />
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header"><div className="card-title">🎨 Couleurs de la marque</div></div>
            <div className="card-body">
              <div className="form-group">
                <label className="form-label">Couleur principale</label>
                <div className="color-row">
                  <input type="color" value={brand} onChange={(e) => setBrand(e.target.value)}
                    style={{ width: '40px', height: '40px', borderRadius: '10px', border: '2px solid var(--border)', cursor: 'pointer', background: 'none', padding: '2px' }}
                    data-testid="color-picker"
                  />
                  <input className="form-input" value={brand} onChange={(e) => setBrand(e.target.value)} style={{ fontFamily: 'monospace' }} data-testid="color-text" />
                </div>
                <div className="color-swatch-row">
                  {SWATCHES.map((c) => (
                    <div
                      key={c}
                      className={'swatch' + (brand.toLowerCase() === c.toLowerCase() ? ' selected' : '')}
                      style={{ background: c }}
                      onClick={() => { setBrand(c); showToast('Couleur appliquée — aperçu mis à jour'); }}
                      data-testid={`swatch-${c}`}
                    ></div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header"><div className="card-title">🖼️ Logo</div></div>
            <div className="card-body">
              <div className="logo-preview">{shortName === 'REF' ? 'Ref' : shortName}</div>
              <div className="logo-upload" onClick={() => showToast('Upload de logo — intégration en production')}>
                <div className="logo-upload-icon">📁</div>
                <div className="logo-upload-text">Glisser votre logo ici ou cliquer pour parcourir</div>
                <div className="logo-upload-sub">PNG, SVG, JPG · Max 2 Mo · Recommandé : 200×200px</div>
              </div>
            </div>
          </div>
        </div>

        {/* PRÉVISUALISATION EN DIRECT */}
        <div>
          <div className="card" style={{ position: 'sticky', top: '80px' }}>
            <div className="card-header"><div className="card-title">👁️ Aperçu en direct</div><span style={{ fontSize: '11px', color: 'var(--green)' }}>● Live</span></div>
            <div className="card-body" style={{ padding: '12px' }}>
              <div className="site-preview">
                <div className="sp-bar">
                  <div className="sp-dots">
                    <div className="sp-dot" style={{ background: '#ff5c6a' }}></div>
                    <div className="sp-dot" style={{ background: '#ffad4d' }}></div>
                    <div className="sp-dot" style={{ background: '#22d3a0' }}></div>
                  </div>
                  <div className="sp-url">ref-reseau.fr</div>
                </div>
                <div className="sp-content">
                  <div className="sp-nav">
                    <div className="sp-nav-logo" data-testid="sp-logo">{shortName === 'REF' ? 'Ref' : shortName}</div>
                    <button className="sp-nav-btn">Adhérer →</button>
                  </div>
                  <div className="sp-hero">
                    <div className="sp-hero-title" data-testid="sp-title">{slogan.slice(0, 60) || 'Votre slogan ici'}</div>
                    <div className="sp-hero-sub">{desc.slice(0, 100)}</div>
                    <div className="sp-stats">
                      <div className="sp-stat"><div className="sp-stat-val" data-testid="sp-members">{totalMembres}</div><div className="sp-stat-lbl">Membres</div></div>
                      <div className="sp-stat"><div className="sp-stat-val">38</div><div className="sp-stat-lbl">Rencontres/an</div></div>
                      <div className="sp-stat"><div className="sp-stat-val">12+</div><div className="sp-stat-lbl">Secteurs</div></div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ marginTop: '14px', padding: '12px', background: 'var(--surface2)', borderRadius: '10px' }}>
                <div style={{ fontSize: '11px', fontWeight: 700, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '8px' }}>Statistiques live du site</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '4px' }}><span style={{ color: 'var(--muted)' }}>Membres affichés</span><span style={{ fontWeight: 700, color: 'var(--brand)' }}>{totalMembres}</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '4px' }}><span style={{ color: 'var(--muted)' }}>Visites site public</span><span style={{ fontWeight: 700 }}>1 240 ce mois</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px' }}><span style={{ color: 'var(--muted)' }}>Inscriptions site</span><span style={{ fontWeight: 700, color: 'var(--green)' }}>18 ce mois</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '6px' }}>
        <button className="btn btn-ghost">Annuler</button>
        <button className="btn btn-primary" onClick={saveConfig} disabled={livePending} data-testid="btn-save-config">💾 Sauvegarder & Publier</button>
      </div>
    </div>
  )}

  {/* STRIPE */}
  {tab === 'stripe' && (
    <div data-testid="tab-stripe">
      <div className="grid-2">
        <div>
          <div className="stripe-card">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
              <div style={{ width: '40px', height: '40px', background: '#635bff', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, color: 'white', fontSize: '18px' }}>S</div>
              <div><div style={{ fontSize: '15px', fontWeight: 700 }}>Stripe Connect</div><div style={{ fontSize: '12px', color: 'var(--muted)' }}>Paiements directs sur votre compte</div></div>
            </div>
            <div className="stripe-status ss-pending">⏳ Compte en cours de vérification</div>
            <div className="stripe-info">
              Avec Stripe Connect, chaque adhésion est versée <strong>directement sur votre compte bancaire</strong>. La plateforme REF prélève automatiquement sa commission (2% + 0,30€/transaction).
            </div>
            <div className="stripe-key">
              <span>Clé publique : pk_live_••••••••••••••••••••••••</span>
              <button className="btn btn-ghost" style={{ fontSize: '11px', padding: '4px 8px' }}>Copier</button>
            </div>
            <div className="stripe-key">
              <span>Clé secrète : sk_live_••••••••••••••••••••••••</span>
              <button className="btn btn-ghost" style={{ fontSize: '11px', padding: '4px 8px' }}>Copier</button>
            </div>
            <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: '8px' }} onClick={() => showToast('Redirection vers Stripe Connect...')}>
              🔗 Connecter mon compte Stripe →
            </button>
          </div>

          <div className="card">
            <div className="card-header"><div className="card-title">💰 Flux financiers</div></div>
            <div className="card-body">
              <div style={{ fontSize: '13px', lineHeight: 1.8 }}>
                <div style={{ padding: '8px 0', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between' }}><span style={{ color: 'var(--muted)' }}>Adhésion 30€</span><span>→ <strong style={{ color: 'var(--green)' }}>28,80€</strong> sur votre compte</span></div>
                <div style={{ padding: '8px 0', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between' }}><span style={{ color: 'var(--muted)' }}>Commission REF</span><span>2% + 0,30€ = <strong>0,90€</strong></span></div>
                <div style={{ padding: '8px 0', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between' }}><span style={{ color: 'var(--muted)' }}>Frais Stripe</span><span>1,4% + 0,25€ = <strong>0,67€</strong></span></div>
                <div style={{ padding: '8px 0', fontSize: '11px', color: 'var(--muted)' }}>Les virements sont effectués automatiquement chaque semaine sur votre IBAN.</div>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header"><div className="card-title">⚙️ Configuration paiement</div></div>
          <div className="card-body">
            <div className="form-group">
              <label className="form-label">IBAN pour les virements</label>
              <input className="form-input" defaultValue="FR76 3000 6000 0112 3456 7890 189" style={{ fontFamily: 'monospace', letterSpacing: '0.05em' }} />
            </div>
            <div className="form-group">
              <label className="form-label">Devise</label>
              <select className="form-input" defaultValue="EUR">
                <option value="EUR">EUR — Euro (€)</option>
                <option value="GBP">GBP — Livre sterling (£)</option>
                <option value="USD">USD — Dollar américain ($)</option>
                <option value="CHF">CHF — Franc suisse</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Paiement en plusieurs fois</label>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px' }}>
                  <input type="checkbox" defaultChecked /> Autoriser le paiement en 2 fois
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px' }}>
                  <input type="checkbox" defaultChecked /> Autoriser le paiement en 3 fois
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px' }}>
                  <input type="checkbox" /> Frais de dossier pour paiement fractionné
                </label>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Reçu automatique</label>
              <select className="form-input" defaultValue="auto">
                <option value="auto">Envoyer un reçu PDF par email automatiquement</option>
                <option value="demand">Reçu uniquement sur demande</option>
              </select>
            </div>
            <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} onClick={() => showToast('Configuration Stripe sauvegardée !')}>Sauvegarder</button>
          </div>
        </div>
      </div>
    </div>
  )}

  {/* FORMULES */}
  {tab === 'formules' && (
    <div data-testid="tab-formules">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <div style={{ fontSize: '14px', color: 'var(--muted)' }}>Configurez vos formules d'adhésion — chaque association choisit ses propres tarifs et fréquences</div>
        <button className="btn btn-primary" onClick={addFormule} data-testid="btn-new-formule">＋ Nouvelle formule</button>
      </div>

      <div>
        {[
          { name: 'Adhésion individuelle', meta: '1 personne · Accès complet · Renouvelable', price: '30€', period: 'par an', status: 'active', muted: false },
          { name: 'Adhésion duo', meta: '2 personnes · Accès complet pour 2', price: '50€', period: 'par an', status: 'active', muted: false },
          { name: 'Adhésion entreprise', meta: 'Jusqu\'à 5 personnes · Facturation société', price: '80€', period: 'par an', status: 'active', muted: false },
          { name: 'Adhésion mensuelle', meta: '1 personne · Sans engagement · Résiliable', price: '4€', period: 'par mois', status: 'draft', muted: true },
        ].map((f, i) => (
          <div className="formule-card" key={i}>
            <div className="formule-color" style={f.muted ? { background: 'var(--muted)' } : undefined}></div>
            <div className="formule-info">
              <div className="formule-name">{f.name}</div>
              <div className="formule-meta">{f.meta}</div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div className="formule-price">{f.price}</div>
              <div className="formule-period">{f.period}</div>
            </div>
            <span className={'tag-sm ' + (f.status === 'active' ? 'tag-active' : 'tag-draft')}>{f.status === 'active' ? 'Actif' : 'Brouillon'}</span>
            <div className="formule-actions">
              <button className="btn btn-ghost" style={{ fontSize: '11px', padding: '5px 9px' }} onClick={() => editFormule(f.name, f.price)}>✏️ Modifier</button>
            </div>
          </div>
        ))}
      </div>

      {formuleEditorOpen && (
        <div className="card" id="refadmin-formule-editor" style={{ marginTop: '18px' }} data-testid="formule-editor">
          <div className="card-header"><div className="card-title">✏️ Créer / Modifier une formule</div></div>
          <div className="card-body">
            <div className="grid-2">
              <div>
                <div className="form-group">
                  <label className="form-label">Nom de la formule</label>
                  <input className="form-input" placeholder="Ex: Adhésion individuelle" value={feNom} onChange={(e) => setFeNom(e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Description</label>
                  <input className="form-input" placeholder="Ex: 1 personne, accès complet" value={feDesc} onChange={(e) => setFeDesc(e.target.value)} />
                </div>
                <div className="grid-2">
                  <div className="form-group">
                    <label className="form-label">Prix</label>
                    <input className="form-input" type="number" placeholder="30" value={fePrix} onChange={(e) => setFePrix(e.target.value)} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Fréquence</label>
                    <select className="form-input" value={feFreq} onChange={(e) => setFeFreq(e.target.value)}>
                      <option value="mensuel">Mensuel</option>
                      <option value="trimestriel">Trimestriel</option>
                      <option value="semestriel">Semestriel</option>
                      <option value="annuel">Annuel</option>
                      <option value="ponctuel">Ponctuel (1 fois)</option>
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Nombre de membres inclus</label>
                  <input className="form-input" type="number" placeholder="1" />
                </div>
                <div className="form-group">
                  <label className="form-label">Options</label>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px' }}><input type="checkbox" defaultChecked /> Facturation société disponible</label>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px' }}><input type="checkbox" defaultChecked /> Paiement en plusieurs fois autorisé</label>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px' }}><input type="checkbox" /> Formule visible sur le site public</label>
                  </div>
                </div>
              </div>
              <div>
                <div className="form-group">
                  <label className="form-label">Statut</label>
                  <select className="form-input">
                    <option>Actif — visible sur le site</option>
                    <option>Brouillon — non visible</option>
                    <option>Archivé</option>
                  </select>
                </div>
                <div style={{ padding: '16px', background: 'var(--surface2)', borderRadius: '12px', marginTop: '8px' }}>
                  <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--muted)', marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Aperçu formule</div>
                  <div style={{ fontSize: '22px', fontWeight: 800, color: 'var(--brand)' }}>{fePreviewPrice}</div>
                  <div style={{ fontSize: '11px', color: 'var(--muted)' }}>{fePreviewPeriod}</div>
                  <div style={{ fontSize: '12px', color: 'var(--muted)', marginTop: '6px' }}>{fePreviewName}</div>
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '8px' }}>
              <button className="btn btn-ghost" onClick={() => setFormuleEditorOpen(false)}>Annuler</button>
              <button className="btn btn-primary" onClick={() => { showToast('Formule sauvegardée !'); setFormuleEditorOpen(false); }}>💾 Sauvegarder la formule</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )}

  {/* SITE PUBLIC */}
  {tab === 'sitePublic' && (
    <div data-testid="tab-sitePublic">
      <div className="grid-2">
        <div className="card">
          <div className="card-header"><div className="card-title">🌐 Domaine & URL</div></div>
          <div className="card-body">
            <div className="form-group">
              <label className="form-label">Sous-domaine REF</label>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <input className="form-input" defaultValue="ref-fugakwa" style={{ flex: 1 }} />
                <span style={{ color: 'var(--muted)', fontSize: '13px', whiteSpace: 'nowrap' }}>.plateforme-ref.fr</span>
              </div>
              <div className="form-hint">Votre site : ref-fugakwa.plateforme-ref.fr</div>
            </div>
            <div className="form-group">
              <label className="form-label">Domaine personnalisé (optionnel)</label>
              <input className="form-input" placeholder="www.ref-reseau.fr" />
              <div className="form-hint">Nécessite une configuration DNS chez votre hébergeur</div>
            </div>
            <button className="btn btn-ghost" style={{ width: '100%', justifyContent: 'center', marginTop: '8px' }} onClick={() => showToast('Site public ouvert dans un nouvel onglet')}>🔗 Voir mon site public →</button>
          </div>
        </div>

        <div className="card">
          <div className="card-header"><div className="card-title">📝 Contenu de la page d'accueil</div></div>
          <div className="card-body">
            <div className="form-group">
              <label className="form-label">Titre principal</label>
              <input className="form-input" value={slogan} onChange={(e) => setSlogan(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Texte de présentation</label>
              <textarea className="form-input" value={desc} onChange={(e) => setDesc(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Afficher le compteur de membres</label>
              <select className="form-input">
                <option>Oui — afficher le nombre réel en temps réel</option>
                <option>Non — masquer le compteur</option>
                <option>Arrondi — afficher "200+ membres"</option>
              </select>
            </div>
            <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} onClick={() => showToast('Site public mis à jour !')}>💾 Mettre à jour le site</button>
          </div>
        </div>
      </div>
    </div>
  )}

  {/* PARAMÈTRES */}
  {tab === 'relancesConfig' && (
    <div data-testid="tab-relancesConfig">
      <div className="grid-2">
        <div className="card">
          <div className="card-header"><div className="card-title">⚙️ Paramètres généraux</div></div>
          <div className="card-body">
            <div className="form-group">
              <label className="form-label">Type d'association</label>
              <select className="form-input" defaultValue="reseau">
                <option value="reseau">🏛️ Réseau professionnel</option>
                <option value="sport">⚽ Club sportif</option>
                <option value="culture">🎭 Association culturelle</option>
                <option value="carit">🏥 Association caritative</option>
                <option value="autre">Autre</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Validation des adhésions</label>
              <select className="form-input">
                <option>Manuelle — l'admin valide chaque demande</option>
                <option>Automatique après paiement</option>
                <option>Automatique avec parrainage d'un membre</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Langue</label>
              <select className="form-input">
                <option>Français</option>
                <option>Anglais</option>
                <option>Espagnol</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Fuseau horaire</label>
              <select className="form-input">
                <option>Europe/Paris (UTC+1)</option>
                <option>Europe/London (UTC+0)</option>
              </select>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header"><div className="card-title">🔒 Sécurité & RGPD</div></div>
          <div className="card-body">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <label style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', cursor: 'pointer' }}>
                <input type="checkbox" defaultChecked style={{ marginTop: '2px' }} />
                <div><div style={{ fontSize: '13px', fontWeight: 600 }}>Double authentification (2FA)</div><div style={{ fontSize: '11px', color: 'var(--muted)' }}>Obligatoire pour les admins</div></div>
              </label>
              <label style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', cursor: 'pointer' }}>
                <input type="checkbox" defaultChecked style={{ marginTop: '2px' }} />
                <div><div style={{ fontSize: '13px', fontWeight: 600 }}>Consentement RGPD à l'adhésion</div><div style={{ fontSize: '11px', color: 'var(--muted)' }}>Checkbox obligatoire avant paiement</div></div>
              </label>
              <label style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', cursor: 'pointer' }}>
                <input type="checkbox" style={{ marginTop: '2px' }} />
                <div><div style={{ fontSize: '13px', fontWeight: 600 }}>Suppression auto données inactives</div><div style={{ fontSize: '11px', color: 'var(--muted)' }}>Après 3 ans d'inactivité</div></div>
              </label>
              <label style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', cursor: 'pointer' }}>
                <input type="checkbox" defaultChecked style={{ marginTop: '2px' }} />
                <div><div style={{ fontSize: '13px', fontWeight: 600 }}>Export données membres sur demande</div><div style={{ fontSize: '11px', color: 'var(--muted)' }}>Droit à la portabilité RGPD</div></div>
              </label>
            </div>
            <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: '16px' }} onClick={() => showToast('Paramètres sauvegardés !')}>Sauvegarder</button>
          </div>
        </div>
      </div>
    </div>
  )}

    </div>
  );
}
